import React from 'react';
import { Icon, Text, theme } from 'components';
import styled from 'styled-components';
import {
  ILoadingAttachments,
  ISharedAttachment,
} from 'hooks/contextualChat/useMediaAttachments';
import { Loading } from '@app/react-common';

interface IDocumentsTab {
  documentsDict?: Record<string, Array<ISharedAttachment>>;
  loading?: ILoadingAttachments;
}

const DocumentsTab = ({ documentsDict, loading }: IDocumentsTab) => (
  <>
    {!Object.keys(documentsDict).length ? (
      <Text style={{ textAlign: 'center', marginTop: 12 }}>
        No documents shared yet
      </Text>
    ) : (
      <>
        {Object.entries(documentsDict).map(([month, docs]) => (
          <div key={`month-${month}`} style={{ paddingTop: 24 }}>
            <Text color={theme.textColorSecondary}>{month}</Text>
            <StyledDocumentsContainer>
              {docs.map((doc, idx) => {
                const position =
                  idx === 0
                    ? 'first'
                    : idx === docs.length - 1
                      ? 'last'
                      : 'middle';

                return (
                  <a
                    key={`document-${doc.title}-${idx}`}
                    href={doc.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <StyledDocument $position={position}>
                      {doc?.image ? (
                        <StyledImg
                          src={doc.image}
                          alt={`preview-${doc.image}-${idx}`}
                        />
                      ) : (
                        <Icon type="antdFileTextOutlined" width={50} />
                      )}
                      <Text ellipsis style={{ maxWidth: 178 }}>
                        {doc.title}
                      </Text>
                    </StyledDocument>
                  </a>
                );
              })}
            </StyledDocumentsContainer>
          </div>
        ))}
        {loading.query && <Loading />}
      </>
    )}
  </>
);

const StyledDocument = styled.div<{ $position: 'first' | 'middle' | 'last' }>`
  display: flex;
  min-height: 85px;
  align-items: center;
  flex: 1;
  padding: 0 8px;
  gap: 12px;
  background-color: #fff;
  border: 0.5px solid #f0f0f0;
  cursor: pointer;

  border-radius: ${({ $position }) =>
    $position === 'first'
      ? '8px 8px 0 0'
      : $position === 'last'
        ? '0 0 8px 8px'
        : '0'};

  &:hover {
    border: 0.5px solid ${theme.getColor('primary')};
  }
`;

const StyledDocumentsContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

const StyledImg = styled.img`
  display: block;
  max-width: 50px;
  min-width: 50px;
  min-height: 61px;
  object-fit: cover;
  border-radius: 4px;
`;

export default DocumentsTab;
